import stationDataConfigApi from '@/api/config/stationDataConfig'
import { floorOverlayApi } from '@/api/config'
import { telemetryApi } from '@/api/telemetry'
import { OverlapDetailByFloor } from '@/types/siteOverlap'
import { AssetType, IAsset, IDevice } from '@/types/telemetry'

import NoData from '@/components/common/NoData'
import MapPositionStation, { ChangePositionData } from '@/components/google-map/MapPositionStation'
import { CloseIcon, LocalPinIcon } from '@/components/icons'
import ManualQuestionIcon from '@/components/icons/ManualQuestionIcon'
import SensorIcon from '@/components/icons/SensorIcon'
import SoilIcon from '@/components/icons/SoilIcon'
import StationErrorIcon from '@/components/icons/StationErrorIcon'
import ErrorPage from '@/features/config/components/modal/NotificationModal/ErrorPage'
import TableContainer from '@/features/design-system/components/common/TableContainer'
import { NotifyService } from '@/helpers'
import { usePermission } from '@/hooks/permissions'
import { SearchStation, SetupStation, UPDATE_SOIL_MOISTURE_DATA, UPDATE_STATION_DATA } from '@/types'
import { formatPosition } from '@/ultils'
import {
  Box,
  Button,
  CircularProgress,
  debounce,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { fetchStationMapOverlay } from '@store/slices/DiagnosticMapView/diagnosticMapViewSlice'
import {
  EStationTab,
  fetchFlowSensorData,
  fetchSensorData,
  fetchSoilMoistureData,
  fetchStationData,
  stationGeoTagDeviceSliceActions,
  stationGeoTagDeviceState,
} from '@store/slices/StataionGeoTagDevice/stationGeoTagDeviceSlice'
import { useAppDispatch, useAppSelector } from '@store/stores'
import clsx from 'clsx'
import { memo, useEffect, useMemo, useState } from 'react'
import StationFilterViewV2 from '../../common/FilterStation/StationFilterViewV2'
import classes from './styles.module.scss'

import useTranslation from '@/hooks/useTranslation'
import { MARKER_TYPE } from '@/types/marker'
import SensorIconV2 from '@/components/icons/SensorIconV2'
import { isWeatherStationType } from '@/utils/assetType'

interface Props {
  interfaceId: number
  open: boolean
  onClose: (refresh?: boolean) => void
  tabValue?: string
}

enum STEP {
  CLICK_GEOTAG = 0,
  MOVE_MARKER,
  CLICK_SAVE,
  CONTINUE_GEOTAGGING,
  END_TUTORIALS,
}

export const PinStationsOnMapModal = memo(
  ({ open, interfaceId, tabValue, onClose }: Props) => {
    const { t } = useTranslation()

    const [stations, setStations] = useState<SetupStation[]>([])
    const [soilMoisture, setSoilMoisture] = useState<SetupStation[]>([])
    const [flowSensor, setFlowSensor] = useState<SetupStation[]>([])
    const [sensorDevices, setSensorDevices] = useState<IAsset[]>([])
    const [itemEdit, setItemEdit] = useState<SetupStation>()

    const [refresh, setRefresh] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isFetching, setIsFetching] = useState<boolean>(false)
    const [filteredData, setFilteredData] = useState<any[]>([])

    const { isViewOnly } = usePermission()

    const dispatch = useAppDispatch()
    const stationGeoTagDevice = useAppSelector(stationGeoTagDeviceState)
    // const [tab, setTab] = useState<string>(tabValue || '0')
    const tab = stationGeoTagDevice.tab

    const handleChangeTab = (newTab: EStationTab) => {
      dispatch(stationGeoTagDeviceSliceActions.changeTab({ value: newTab }))
      // if (
      //   tab !== EStationTab.StationData &&
      //   newTab === EStationTab.StationData
      // ) {
      //   dispatch(stationGeoTagDeviceSliceActions.reset())
      // }
    }

    const [step, setStep] = useState(
      localStorage.getItem('pinStationsStep') || STEP.CLICK_GEOTAG,
    )

    let navBarOneWidth: string
    let navBarSecondWidth: string

    const getButtonStyles = (currentTab: EStationTab) => ({
      color: tab === currentTab ? '#fff' : '#004744',
      backgroundColor: tab === currentTab ? '#004744' : '#ebf1f0',
      '&:hover': {
        color: tab === currentTab ? '#fff' : '#004744',
        backgroundColor: tab === currentTab ? '#004744' : '#ebf1f0',
      },
    })

    switch (step) {
      case STEP.CLICK_GEOTAG:
        navBarOneWidth = '25%'
        navBarSecondWidth = '75%'
        break
      case STEP.MOVE_MARKER:
        navBarOneWidth = '50%'
        navBarSecondWidth = '50%'
        break
      case STEP.CLICK_SAVE:
        navBarOneWidth = '75%'
        navBarSecondWidth = '25%'
        break
      case STEP.CONTINUE_GEOTAGGING:
        navBarOneWidth = '100%'
        navBarSecondWidth = '0%'
        break
      default:
        navBarOneWidth = '100%'
        navBarSecondWidth = '0%'
    }

    const _onClose = () => {
      setRefresh(false)
      onClose(refresh)
    }

    const [param] = useState<SearchStation>({
      PageSize: 0,
      interfaceId,
    })

    const [paramSoil] = useState<SearchStation>()

    const onChangePosition = debounce(async (data: ChangePositionData) => {
      try {
        if (!itemEdit || isLoading) return
        setIsLoading(true)

        if (tab === EStationTab.StationData) {
          const body: UPDATE_STATION_DATA = {
            interfaceId: interfaceId,
            locationId: data.locationId,
            floorId: data.floorId,
            stationId: itemEdit.id,
            grsCoordinatedLatitude: data.grsCoordinatedLatitude,
            grsCoordinatedLongitude: data.grsCoordinatedLongitude,
            subAreaId: itemEdit.subAreaId,
          }
          await stationDataConfigApi
            .updateStations([body])
            .then(() => {
              setRefresh(true)

              setStations(
                stations.map((station) =>
                  station.id === itemEdit.id
                    ? Object.assign({}, station, {
                      // siteId: data.siteId,
                      // siteName: data.siteName,
                      locationId: data.locationId,
                      locationName: data.locationName,
                      floorId: data.floorId,
                      grsCoordinatedLatitude: data.grsCoordinatedLatitude,
                      grsCoordinatedLongitude: data.grsCoordinatedLongitude,
                      // subAreaId: data.subAreaId,
                    })
                    : station,
                ),
              )

              setItemEdit(undefined)
              NotifyService.success(t('geotag.stationGeotagSuccess'), {
                position: 'top-center',
              })
            })
            .catch((e) => {
              console.error('ERROR after updating station', e)
              NotifyService.error(e, { position: 'top-center' })
            })
            .finally(() => setIsLoading(false))
        } else if (tab === EStationTab.FlowSensor) {
          const body: UPDATE_SOIL_MOISTURE_DATA = {
            interfaceId: interfaceId,
            locationId: data.locationId,
            floorId: data.floorId,
            sensorId: itemEdit.id,
            grsCoordinatedLatitude: data.grsCoordinatedLatitude,
            grsCoordinatedLongitude: data.grsCoordinatedLongitude,
            subAreaId: itemEdit.subAreaId,
          }
          await stationDataConfigApi
            .updateFlowSensor([body])
            .then(() => {
              setRefresh(true)
              setFlowSensor(
                flowSensor.map((sensor) =>
                  sensor.id === itemEdit.id
                    ? Object.assign({}, sensor, {
                      // siteId: data.siteId,
                      // siteName: data.siteName,
                      locationId: data.locationId,
                      locationName: data.locationName,
                      floorId: data.floorId,
                      grsCoordinatedLatitude: data.grsCoordinatedLatitude,
                      grsCoordinatedLongitude: data.grsCoordinatedLongitude,
                      // subAreaId: data.subAreaId,
                    })
                    : sensor,
                ),
              )
              setItemEdit(undefined)
              NotifyService.success(t('geotag.flowSensorGeotagSuccess'))
            })
            .catch((e) => {
              console.error(e)
              NotifyService.error(e)
            })
            .finally(() => setIsLoading(false))
        } else if (tab === EStationTab.SoilMoisture) {
          const body: UPDATE_SOIL_MOISTURE_DATA = {
            interfaceId: interfaceId,
            locationId: data.locationId,
            floorId: data.floorId,
            sensorId: itemEdit.id,
            grsCoordinatedLatitude: data.grsCoordinatedLatitude,
            grsCoordinatedLongitude: data.grsCoordinatedLongitude,
            subAreaId: itemEdit.subAreaId,
          }
          await stationDataConfigApi
            .updateSoilMoisture([body])
            .then(() => {
              setRefresh(true)
              setSoilMoisture(
                soilMoisture.map((moisture) =>
                  moisture.id === itemEdit.id
                    ? Object.assign({}, moisture, {
                      // siteId: data.siteId,
                      // siteName: data.siteName,
                      locationId: data.locationId,
                      locationName: data.locationName,
                      floorId: data.floorId,
                      grsCoordinatedLatitude: data.grsCoordinatedLatitude,
                      grsCoordinatedLongitude: data.grsCoordinatedLongitude,
                      // subAreaId: data.subAreaId,
                    })
                    : moisture,
                ),
              )
              setItemEdit(undefined)
              NotifyService.success(t('geotag.soilMoistureGeotagSuccess'))
            })
            .catch((e) => {
              console.error(e)
              NotifyService.error(e)
            })
            .finally(() => setIsLoading(false))
        } else if (tab === EStationTab.Sensor) {
          const device = sensorDevices.find((d) => d.id === itemEdit.id)
          if (!device) {
            setIsLoading(false)
            return
          }
          await telemetryApi
            .updateAsset(device.id, {
              name: device.name,
              description: device.description || '',
              type: device.type || '',
              metadata: {
                ...device.metadata,
                latitude: String(data.grsCoordinatedLatitude),
                longitude: String(data.grsCoordinatedLongitude),
                floorId: String(data.floorId),
              },
            })
            .then(() => {
              setRefresh(true)
              setSensorDevices(
                sensorDevices.map((d) =>
                  d.id === device.id
                    ? {
                        ...d,
                        metadata: {
                          ...d.metadata,
                          latitude: String(data.grsCoordinatedLatitude),
                          longitude: String(data.grsCoordinatedLongitude),
                          floorId: String(data.floorId),
                        },
                      }
                    : d,
                ),
              )
              setItemEdit(undefined)
              NotifyService.success(t('geotag.sensorGeotagSuccess'))
            })
            .catch((e) => {
              console.error(e)
              NotifyService.error(e)
            })
            .finally(() => setIsLoading(false))
        }
      } catch (e) {
        console.error(e)
      }
    }, 500)

    const onEditPosition = (item: SetupStation) => {
      if (itemEdit?.id === item.id) return
      setItemEdit(item)
    }

    const handleTutorials = () => {
      setStep(STEP.CLICK_GEOTAG)
    }

    const handleSkip = () => {
      setStep(STEP.END_TUTORIALS)
    }

    const render = () => {
      switch (step) {
        case STEP.CLICK_GEOTAG:
          return (
            <Stack className={classes.boxStepOne} bgcolor="background.default">
              <Stack direction="row" width="100%">
                <Stack
                  className={classes.navBarOne}
                  sx={{ width: navBarOneWidth }}
                />
                <Stack
                  className={classes.navBarSecond}
                  sx={{ width: navBarSecondWidth }}
                />
              </Stack>
              <Box className={classes.bodyBox}>
                <Typography className={classes.stepIndicator}>
                  {t('commonWordStep')} 1/4
                </Typography>
                <Typography className={classes.geoTagTitle}>
                  {t('geotagDecoders')}
                </Typography>
                <Typography className={classes.geoTagInstruction}>
                  {t(
                    'ClickOnGeoTagButtonUnderTheDecoderListToStartGeo-tagging',
                  )}
                </Typography>
              </Box>
              <Stack
                className={classes.footerActionButtons}
                direction="row"
                spacing={2}
              >
                <Button variant="secondary" onClick={handleSkip}>
                  {t('commonActionsSkip')}
                </Button>
                <Button
                  variant="primary"
                  onClick={() => setStep(STEP.MOVE_MARKER)}
                >
                  {t('commonActionsNext')}
                </Button>
              </Stack>
            </Stack>
          )
        case STEP.MOVE_MARKER:
          return (
            <Stack
              className={classes.boxStepSecond}
              bgcolor="background.default"
            >
              <Stack direction="row" width="100%">
                <Stack
                  className={classes.navBarOne}
                  sx={{ width: navBarOneWidth }}
                />
                <Stack
                  className={classes.navBarSecond}
                  sx={{ width: navBarSecondWidth }}
                />
              </Stack>
              <Box className={classes.bodyBox}>
                <Typography className={classes.stepIndicator}>
                  {t('commonWordStep')} 2/4
                </Typography>
                <Typography className={classes.geoTagTitle}>
                  {t('geotagDecoders')}
                </Typography>
                <Typography className={classes.geoTagInstruction}>
                  {t('moveTheMarkerOnTheMapToTheCorrectLocationOfTheDecoder')}
                </Typography>
                <Stack direction="row" justifyContent="space-between" mt="30px">
                  <Button
                    className={classes.btnBack}
                    onClick={() => setStep(STEP.CLICK_GEOTAG)}
                    sx={{
                      color: 'text.main',
                      '&:hover': { color: 'text.main' },
                    }}
                  >
                    {t('commonActionsBack')}
                  </Button>
                  <Stack
                    className={classes.footerActionButtons}
                    direction="row"
                    spacing={2}
                  >
                    <Button variant="secondary" onClick={handleSkip}>
                      {t('commonActionsSkip')}
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => setStep(STEP.CLICK_SAVE)}
                    >
                      {t('commonActionsNext')}
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          )
        case STEP.CLICK_SAVE:
          return (
            <Stack
              className={classes.boxStepThird}
              bgcolor="background.default"
            >
              <Stack direction="row" width="100%">
                <Stack
                  className={classes.navBarOne}
                  sx={{ width: navBarOneWidth }}
                />
                <Stack
                  className={classes.navBarSecond}
                  sx={{ width: navBarSecondWidth }}
                />
              </Stack>
              <Box className={classes.bodyBox}>
                <Typography className={classes.stepIndicator}>
                  {t('commonWordStep')} 3/4
                </Typography>
                <Typography className={classes.geoTagTitle}>
                  {t('geotagDecoders')}
                </Typography>
                <Typography className={classes.geoTagInstruction}>
                  {t('commonActionsClick')}{' '}
                  <Typography
                    className={classes.txtSave}
                    color="primary.contrastText"
                  >
                    {t('commonActionsSave')}
                  </Typography>
                </Typography>
                <Stack direction="row" justifyContent="space-between" mt="30px">
                  <Button
                    className={classes.btnBack}
                    onClick={() => setStep(STEP.MOVE_MARKER)}
                    sx={{
                      color: 'text.main',
                      '&:hover': { color: 'text.main' },
                    }}
                  >
                    {t('commonActionsBack')}
                  </Button>
                  <Stack
                    className={classes.footerActionButtons}
                    direction="row"
                    spacing={2}
                  >
                    <Button variant="secondary" onClick={handleSkip}>
                      {t('commonActionsSkip')}
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => setStep(STEP.CONTINUE_GEOTAGGING)}
                    >
                      {t('commonActionsNext')}
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          )

        case STEP.CONTINUE_GEOTAGGING:
          return (
            <Stack className={classes.boxStepFour} bgcolor="background.default">
              <Stack direction="row" width="100%">
                <Stack
                  className={classes.navBarOne}
                  sx={{ width: navBarOneWidth }}
                />
                <Stack
                  className={classes.navBarSecond}
                  sx={{ width: navBarSecondWidth }}
                />
              </Stack>
              <Box className={classes.bodyBox}>
                <Typography className={classes.stepIndicator}>
                  {t('commonWordStep')} 4/4
                </Typography>
                <Typography className={classes.geoTagTitle}>
                  {t('geotagDecoders')}
                </Typography>
                <Typography className={classes.geoTagInstruction}>
                  {t('ContinueToGeotagTheRestOfTheDecoders')}
                </Typography>
                <Stack direction="row" justifyContent="space-between" mt="30px">
                  <Button
                    className={classes.btnBack}
                    onClick={() => setStep(STEP.CLICK_SAVE)}
                    sx={{
                      color: 'text.main',
                      '&:hover': { color: 'text.main' },
                    }}
                  >
                    {t('commonActionsBack')}
                  </Button>
                  <Stack className={classes.footerActionButtons}>
                    <Button
                      variant="primary"
                      onClick={() => setStep(STEP.END_TUTORIALS)}
                    >
                      {t('mapViewDoneButton')}
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          )
      }
    }

    useEffect(() => {
      // Lấy giá trị từ localStorage
      const storedStep = localStorage.getItem('pinStationsStep')
      if (storedStep !== null) {
        setStep(parseInt(storedStep)) // Chuyển đổi chuỗi thành số nguyên
      }
    }, [])

    useEffect(() => {
      // Lưu giá trị của step vào localStorage khi step thay đổi
      localStorage.setItem('pinStationsStep', String(step))
    }, [step])

    useEffect(() => {
      if (step === 0) {
        setItemEdit(stations[0])
      }
    }, [step, stations])

    useEffect(() => {
      if (interfaceId && open) {
        /**
         * @todo:
         * adjust dependencies to refetch on tab change only
         * fetchData()
         * fetchSoilData()
         * fetchFlowData()
         */
        setIsFetching(true)
        dispatch(
          fetchStationData({
            PageSize: 0,
            interfaceId,
            // ...stationGeoTagDevice.filter,
          }),
        )
          .unwrap()
          .then((data) => {
            const newData = [...data].map((it) => ({
              ...it,
              markertType: MARKER_TYPE.Valve_OFF,
            }))
            setStations(newData)
          })
          .catch((e) => {
            NotifyService.error(e)
          })
          .finally(() => {
            setItemEdit(undefined)
            setIsFetching(false)
          })
      }
      //eslint-disable-next-line
    }, [interfaceId, open])

    useEffect(() => {
      let result = stations
      result = result.filter((station: any) => {
        const matchesKeyword = stationGeoTagDevice.filter.Keyword
          ? station.controller
            ?.toLowerCase()
            .includes(stationGeoTagDevice.filter.Keyword.toLowerCase())
          : true
        const matchesSubArea = stationGeoTagDevice.filter.SubAreaIds?.length
          ? stationGeoTagDevice.filter.SubAreaIds.includes(station.subAreaId)
          : true
        const matchesPlant = stationGeoTagDevice.filter.PlantIds?.length
          ? stationGeoTagDevice.filter.PlantIds.includes(station.plantId)
          : true
        const matchesSoil = stationGeoTagDevice.filter.SoilIds?.length
          ? stationGeoTagDevice.filter.SoilIds.includes(station.soilId)
          : true
        const matchesEmitter = stationGeoTagDevice.filter.EmitterIds?.length
          ? stationGeoTagDevice.filter.EmitterIds.includes(station.emitterId)
          : true

        return (
          matchesKeyword &&
          matchesSubArea &&
          matchesPlant &&
          matchesSoil &&
          matchesEmitter
        )
      })

      setFilteredData(result)
    }, [stations, stationGeoTagDevice.filter])

    useEffect(() => {
      /**
       * @todo: get stations from: diagnosticMapView/fetchStationMapOverlay
       */
      if (interfaceId && open) {
        dispatch(
          fetchSoilMoistureData({
            interfaceId,
            paramSoil: {
              interfaceId,
              PageSize: 0,
              ...stationGeoTagDevice.filterSoilMoisture,
            },
          }),
        )
          .unwrap()
          .then((data) => {
            const newData = [...data].map((it) => ({
              ...it,
              markertType: MARKER_TYPE.Soil_Moisture_Sensor,
            }))
            setSoilMoisture([...newData])
          })
          .catch((e) => {
            NotifyService.error(e)
            setSoilMoisture([])
          })
          .finally(() => {
            setItemEdit(undefined)
          })
      }
    }, [interfaceId, open, stationGeoTagDevice.filterSoilMoisture])

    useEffect(() => {
      if (interfaceId && open) {
        dispatch(fetchSensorData(interfaceId))
          .unwrap()
          .then((data) => {
            console.log('Fetched sensor devices:', data)
            setSensorDevices(data)
          })
          .catch((e) => {
            NotifyService.error(e)
            setSensorDevices([])
          })
          .finally(() => {
            setItemEdit(undefined)
          })
      }
    }, [interfaceId, open, stationGeoTagDevice.filterSensor])

    useEffect(() => {
      if (interfaceId && open) {
        /**
         * @todo:
         * adjust dependencies to refetch on tab change only
         * fetchData()
         * fetchSoilData()
         * fetchFlowData()
         */
        dispatch(
          fetchFlowSensorData({
            interfaceId,
            paramSoil: {
              interfaceId,
              PageSize: 0,
              ...stationGeoTagDevice.filterFlowSensor,
            },
          }),
        )
          .unwrap()
          .then((data) => {
            const newData = [...data].map((it) => ({
              ...it,
              markertType: MARKER_TYPE.Flow_Sensor,
            }))
            setFlowSensor(newData)
          })
          .catch((e) => {
            NotifyService.error(e)
            setFlowSensor([]) // Set to empty array on error
          })
          .finally(() => {
            setItemEdit(undefined)
          })
      }
      //eslint-disable-next-line
    }, [interfaceId, open, stationGeoTagDevice.filterFlowSensor])

    useEffect(() => {
      if ((tab ?? null) !== null) {
        setItemEdit(undefined)
      }
    }, [tab])

    useEffect(() => {
      dispatch(fetchStationMapOverlay(interfaceId)).unwrap()
      return () => {
        dispatch(stationGeoTagDeviceSliceActions.reset())
      }
    }, [])

    const handleMarkerClick = (
      stationId: number,
      markertType?: MARKER_TYPE,
    ) => {
      const found = allStations.find(
        (s) => s.id === stationId && s.markertType === markertType,
      )
      if (found) {
        onEditPosition(found)
        scrollIntoView(stationId, markertType)
      }
    }

    const scrollIntoView = (stationId: number, markertType?: MARKER_TYPE) => {
      setTimeout(() => {
        const row = document.querySelector(
          `[data-station-id="${stationId}"][data-marker-type="${markertType}"]`,
        )
        if (row) {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 200)
    }

    const [allFloorOverlays, setAllFloorOverlays] = useState<
      OverlapDetailByFloor[]
    >([])

    useEffect(() => {
      fetchOverLay()
    }, [])
    useEffect(() => {
      console.log(allFloorOverlays)
    }, [allFloorOverlays])

    const fetchOverLay = async () => {
      const { data } = await floorOverlayApi.getListByInterfaceId(interfaceId, {
        PageSize: 0,
      })
      if (data) {
        setAllFloorOverlays([...data.data])
      }
    }

    const getSensorMarkerType = (device: IAsset): MARKER_TYPE => {
      if (device.metadata?.source === 'Zeus') return MARKER_TYPE.Sensor_Station_Normal
      switch (
        isWeatherStationType(device.metadata?.type)
          ? AssetType.WeatherStation
          : device.metadata?.type
      ) {
        case AssetType.WeatherStation: return MARKER_TYPE.Weather_Station
        case AssetType.SoilSensor: return MARKER_TYPE.Soil_Moisture_Sensor
        case AssetType.FlowSensor: return MARKER_TYPE.Flow_Sensor
        case AssetType.TankLevelSensor: return MARKER_TYPE.Flow_Sensor
        default: return MARKER_TYPE.Generic_Sensor
      }
    }

    const filteredSensors = useMemo(() => {
      const keyword = stationGeoTagDevice.filterSensor.Keyword?.toLowerCase()
      const types = stationGeoTagDevice.filterSensor.Types
      return sensorDevices.filter((d) => {
        const matchesKeyword = keyword ? d.name?.toLowerCase().includes(keyword) : true
        const matchesType = types.length > 0 ? types.includes(d.metadata?.type || '') : true
        return matchesKeyword && matchesType
      })
    }, [sensorDevices, stationGeoTagDevice.filterSensor.Keyword, stationGeoTagDevice.filterSensor.Types])

    const sensorsForMap = useMemo(
      () =>
        filteredSensors.map((d) => {
          const parsedFloorId = Number(d.metadata?.floorId)
          return {
            id: d.id,
            description: d.name,
            grsCoordinatedLatitude: d.metadata?.latitude ? Number(d.metadata.latitude) : null,
            grsCoordinatedLongitude: d.metadata?.longitude ? Number(d.metadata.longitude) : null,
            markertType: getSensorMarkerType(d),
            floorId: !isNaN(parsedFloorId) && parsedFloorId > 0 ? parsedFloorId : null,
          } as SetupStation
        }),
      [filteredSensors],
    )

    const sensorsWithCoords = useMemo(
      () => sensorsForMap.filter((s) => s.grsCoordinatedLatitude && s.grsCoordinatedLongitude),
      [sensorsForMap],
    )

    const allStations = useMemo(() => {
      return [...filteredData, ...flowSensor, ...soilMoisture, ...sensorsWithCoords]
    }, [stations, filteredData, flowSensor, soilMoisture, sensorsWithCoords])

    if (isViewOnly) return null

    return (
      <Dialog fullScreen open={open} scroll="paper">
        <DialogTitle className={classes.header} component="div">
          <Box className={classes.headerBtn} onClick={_onClose}>
            <CloseIcon />
          </Box>
          <Stack direction="row" spacing={58}>
            <Typography className={classes.headerText}>
              {t('geotagDevice')}
            </Typography>
            <Stack>
              <IconButton onClick={handleTutorials}>
                <ManualQuestionIcon sx={{ color: 'text.main' }} />
              </IconButton>
            </Stack>
          </Stack>
          <ErrorPage sx={{ position: 'absolute', right: 0 }} />
        </DialogTitle>

        <DialogContent className={classes.contentRoot}>
          <Box className={classes.leftBox}>
            <Box className={classes.topBox}>
              <Stack direction="row" spacing={1}>
                <Button
                  className={classes.btnStatus}
                  startIcon={<StationErrorIcon />}
                  onClick={() => handleChangeTab(EStationTab.StationData)}
                  sx={getButtonStyles(EStationTab.StationData)}
                >
                  {t('stations')}
                </Button>
                {/* <Button
                  className={classes.btnStatus}
                  startIcon={<SensorIcon sx={{ color: '#29aae1' }} />}
                  onClick={() => handleChangeTab(EStationTab.FlowSensor)}
                  sx={getButtonStyles(EStationTab.FlowSensor)}
                >
                  {t('flowSensor')}
                </Button>

                <Button
                  className={classes.btnStatus}
                  startIcon={<SoilIcon sx={{ color: '#ffef98' }} />}
                  onClick={() => handleChangeTab(EStationTab.SoilMoisture)}
                  sx={getButtonStyles(EStationTab.SoilMoisture)}
                >
                  {t('soilMoisture')}
                </Button> */}

                <Button
                  className={classes.btnStatus}
                  startIcon={<SensorIconV2 sx={{ color: '#29aae1' }} />}
                  onClick={() => handleChangeTab(EStationTab.Sensor)}
                  sx={getButtonStyles(EStationTab.Sensor)}
                >
                  {t('Sensor')}
                </Button>
              </Stack>
            </Box>

            <StationFilterViewV2
              currentFilter={stationGeoTagDevice.filter}
              removeAll={false}
              parentCallback={() => {
              }}
            />

            <Box
              className={classes.content}
              sx={{
                ...(step !== STEP.END_TUTORIALS && {
                  opacity: 0.5,
                  userSelect: 'none',
                  pointerEvents: 'none',
                }),
              }}
            >
              {tab === EStationTab.StationData && (
                <TableContainer id="scrollableDiv">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ minWidth: '30px' }}>
                          {t('tableHeaderId')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '155px' }}>
                          {t('decoderName')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '118px' }}>
                          {t('commonUnitsArea')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '118px' }}>
                          {t('subArea')}
                        </TableCell>
                        <TableCell>{t('gpsCoordinates')}</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {isFetching == true && (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            <Stack
                              height="40vh"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <CircularProgress />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      )}
                      {!isFetching &&
                        filteredData.map((row) => (
                          <TableRow
                            key={row.id}
                            data-station-id={row.id}
                            data-marker-type={row.markertType}
                            className={clsx({
                              [classes.rowAction]: row.id === itemEdit?.id,
                            })}
                          >
                            <TableCell>{row.id}</TableCell>
                            <TableCell>{row.controller}</TableCell>
                            <TableCell>{row?.areaName || '-'}</TableCell>
                            <TableCell>{row?.subAreaName || '-'}</TableCell>
                            <TableCell>
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                className={classes.positionBox}
                                onClick={() => onEditPosition(row)}
                              >
                                <Typography
                                  color="primary.contrastText"
                                  className={classes.positionText}
                                >
                                  {row.grsCoordinatedLatitude &&
                                  row.grsCoordinatedLongitude
                                    ? formatPosition(
                                      new google.maps.LatLng(
                                        row.grsCoordinatedLatitude,
                                        row.grsCoordinatedLongitude,
                                      ),
                                    )
                                    : 'Pin on Map'}
                                </Typography>
                                <LocalPinIcon
                                  className={classes.positionIcon}
                                  sx={{ color: 'primary.contrastText' }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {tab === EStationTab.FlowSensor && (
                <>
                  {flowSensor && flowSensor.length === 0 && (
                    <NoData text="No Data" />
                  )}
                  {flowSensor && flowSensor.length > 0 && (
                    <TableContainer id="scrollableDiv">
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ minWidth: '155px' }}>
                              {t('commonLabelsDescription')}
                            </TableCell>
                            <TableCell>{t('gpsCoordinates')}</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {flowSensor.map((row) => (
                            <TableRow
                              key={row.id}
                              data-station-id={row.id}
                              data-marker-type={row.markertType}
                              className={clsx({
                                [classes.rowAction]: row.id === itemEdit?.id,
                              })}
                            >
                              <TableCell>{row.description}</TableCell>
                              <TableCell>
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                  onClick={() => onEditPosition(row)}
                                >
                                  <Typography
                                    color="primary.contrastText"
                                    className={classes.positionText}
                                  >
                                    {row.grsCoordinatedLatitude &&
                                    row.grsCoordinatedLongitude
                                      ? formatPosition(
                                        new google.maps.LatLng(
                                          row.grsCoordinatedLatitude,
                                          row.grsCoordinatedLongitude,
                                        ),
                                      )
                                      : t('stationsPinOnMap')}
                                  </Typography>
                                  <LocalPinIcon
                                    className={classes.positionIcon}
                                    sx={{ color: 'primary.contrastText' }}
                                  />
                                </Stack>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </>
              )}
              {tab === EStationTab.SoilMoisture && (
                <>
                  {soilMoisture && soilMoisture.length === 0 && (
                    <NoData text={t('commonStatusNoData')} />
                  )}
                  {soilMoisture && soilMoisture.length > 0 && (
                    <TableContainer id="scrollableDiv">
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ minWidth: '155px' }}>
                              {t('commonLabelsDescription')}
                            </TableCell>
                            <TableCell>{t('gpsCoordinates')}</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {soilMoisture.map((row) => (
                            <TableRow
                              key={row.id}
                              data-station-id={row.id}
                              data-marker-type={row.markertType}
                              className={clsx({
                                [classes.rowAction]: row.id === itemEdit?.id,
                              })}
                            >
                              <TableCell>{row.description}</TableCell>
                              <TableCell>
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                  className={classes.positionBox}
                                  onClick={() => onEditPosition(row)}
                                >
                                  <Typography
                                    color="primary.contrastText"
                                    className={classes.positionText}
                                  >
                                    {row.grsCoordinatedLatitude &&
                                    row.grsCoordinatedLongitude
                                      ? formatPosition(
                                        new google.maps.LatLng(
                                          row.grsCoordinatedLatitude,
                                          row.grsCoordinatedLongitude,
                                        ),
                                      )
                                      : t('stationsPinOnMap')}
                                  </Typography>
                                  <LocalPinIcon
                                    className={classes.positionIcon}
                                    sx={{ color: 'primary.contrastText' }}
                                  />
                                </Stack>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </>
              )}

              {tab === EStationTab.Sensor && (
                <>
                  {filteredSensors.length === 0 && (
                    <NoData text={t('commonStatusNoData')} />
                  )}
                  {filteredSensors.length > 0 && (
                    <TableContainer id="scrollableDiv">
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ minWidth: '155px' }}>
                              {t('commonLabelsDescription')}
                            </TableCell>
                            <TableCell sx={{ minWidth: '120px' }}>
                              {t('sensorType')}
                            </TableCell>
                            <TableCell sx={{ minWidth: '80px' }}>
                              {t('floorId')}
                            </TableCell>
                            <TableCell>{t('gpsCoordinates')}</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {filteredSensors.map((row) => {
                            const mapRow = sensorsForMap.find((s) => s.id === row.id)
                            const lat = row.metadata?.latitude
                            const lng = row.metadata?.longitude
                            const markerType = getSensorMarkerType(row)
                            return (
                              <TableRow
                                key={row.id}
                                data-station-id={row.id}
                                data-marker-type={markerType}
                                className={clsx({
                                  [classes.rowAction]: row.id === itemEdit?.id,
                                })}
                              >
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.metadata?.type || '-'}</TableCell>
                                <TableCell>{row.metadata?.floorId || '-'}</TableCell>
                                <TableCell>
                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    className={classes.positionBox}
                                    onClick={() => mapRow && onEditPosition(mapRow)}
                                  >
                                    <Typography
                                      color="primary.contrastText"
                                      className={classes.positionText}
                                    >
                                      {lat && lng
                                        ? `${lat}, ${lng}`
                                        : t('stationsPinOnMap')}
                                    </Typography>
                                    <LocalPinIcon
                                      className={classes.positionIcon}
                                      sx={{ color: 'primary.contrastText' }}
                                    />
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </>
              )}
            </Box>
          </Box>

          <Stack sx={{ flex: '1', height: '100%', position: 'relative' }}>
            <Box
              className={classes.mapBox}
              sx={{
                ...(step !== STEP.END_TUTORIALS && {
                  opacity: 0.5,
                  userSelect: 'none',
                  pointerEvents: 'none',
                }),
              }}
            >
              <MapPositionStation
                allowChangePositionCoordinate
                isFilterByFloor
                isCheckMarkertType
                interfaceId={interfaceId}
                station={itemEdit}
                onDone={onChangePosition}
                onMarkerClick={handleMarkerClick}
                tab={tab as any}
                allStations={allStations}
                allFloorOverlays={allFloorOverlays}
                bypassFloorFilterMarkerTypes={[
                  MARKER_TYPE.Weather_Station,
                  MARKER_TYPE.Soil_Moisture_Sensor,
                  MARKER_TYPE.Flow_Sensor,
                  MARKER_TYPE.Temp_Sensor,
                  MARKER_TYPE.Generic_Sensor,
                  MARKER_TYPE.Sensor_Station_Normal,
                ]}
                skipLocationValidation={tab === EStationTab.Sensor}
              />
            </Box>
            <Box>{render()}</Box>
          </Stack>
        </DialogContent>
      </Dialog>
    )
  },
)

export default PinStationsOnMapModal
